<template>
  <div class="videoPreview">
    <v-header :headTitle='headTitle' id='header' v-if='$route.query.isShowPdfHead=="1"&&$route.query.source==0' :isBack='true' :pageName="pageName" ></v-header>
    <div class="container">
      <div class="video-box">
        <!-- <video v-if='previewUrl' crossorigin="anonymous" :poster='vedioPicUrl' id='videoPlay' x5-video-player-type='h5-page' controlslist="nodownload" :src="previewUrl" controls autoplay></video> -->
        <!-- andriod手机下存在点击全屏就闪退的情况，andriod描述说是进入onShowCustomView执行全屏后里面又执行了onHideCustomView关闭全屏造成的闪退（正常是点击关闭全屏才执行onHide），原因未知，尝试替换成阿里云播放器 -->
        <aliplayer ref="aliplayer" :currentVideoUrl='previewUrl'></aliplayer>
      </div>
    </div>
  </div>
</template>

<script>
  import header from '../../components/header/header'
  import aliplayer from "../../components/aliplayer/video.vue";
  export default {
    components: {
      'v-header': header,
      aliplayer
    },
    created() {
      if(this.$route.query.title){
        this.headTitle = this.$route.query.title
      }
      this.previewUrl = this.$route.query.url
    },
    mounted() {
      setTimeout(()=>{
        // this.findvideocover()
      },1000)
      this.$nextTick(()=>{
        this.$refs.aliplayer.initVideo()
      })
    },
    data() {
      return {
        headTitle: '视频预览',
        pageName: '',
        previewUrl: '',
        vedioPicUrl:'',
      }
    },
    methods: {
      findvideocover() {
        // 获取video节点
        const video = document.getElementById("videoPlay");
        console.log(video,'videoDom');
        video.width = video.offsetWidth
        video.height = video.offsetHeight
        video.currentTime = 1 // 第一帧
        //创建canvas对象
        const canvas = document.createElement("canvas")
        canvas.width = video.offsetWidth
        canvas.height = video.offsetHeight
        this.$nextTick(()=>{
          // 利用canvas对象方法绘图
          canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
          // 转换成base64形式
          this.vedioPicUrl  = canvas.toDataURL("image/jpeg") // 这个就是图片的base64
        })
      },
    },
  }
</script>

<style lang='scss' scoped>
  .videoPreview {
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    .container{
      .video-box{
        video{
          width: 100%;
          height: 100%;
        }

      }
    }
  }
</style>
